/**
 * Enumeration for image sizes
 * @enum {number}
 * @readonly
 * @description Image sizes in pixels for the largest side of the image.
 */
export enum FalcorImageSize {
    /**
     * 1024 pixels image size
     */
    Size1024 = 1024,

    /**
     * 2048 pixels image size
     */
    Size2048 = 2048,
}
